import axios from 'axios';
import authHeader from './auth-header';
import config from '../Config';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;

const getFinancialYearList = (page, pagesize, search) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/financial-year/', {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      search: search
    },
  });
};

const changeFinancialYear = id => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/financial-year/set-current/`, 
    {fid: id}, 
    { headers: authHeader() }, 
  );
};


const financialYearService = {
  getFinancialYearList,
  changeFinancialYear
};
export default financialYearService;


